export default "__VITE_ASSET__435ce558__"